import gql from 'graphql-tag';


const TENANT_DETAIL_FRAGMENT = gql`
	fragment tenant on Tenant {
		id
		name
		isMaster
		email
		timezone
		windcaveCustomerId
		netcardCustomerId
		awsUserId
		logoUrl
		publicName
		publicEmail
		publicPhoneNumber
		masterTenant {
			id
			tenantSettings {
				id
				managesSlaveProducts
				managesSlaveConstants
				managesSlaves
				managesSlaveLocationsClients
				managesSlaveMachines
				managesSlaveTags
				managesSlaveClients
				managesSlaveCommissions
				showPickListRecalculationDialog
			}
		}
		integrations
	}
`;

export const GET_TENANT_DETAIL = gql`
	query($id: String) {
		getTenant(id: $id) {
			...tenant
		}
	}
	${TENANT_DETAIL_FRAGMENT}
`;



export const MODIFY_TENANT = gql`
	mutation modifyTenantMutation($input: ModifyTenantInput!) {
		modifyTenant(input: $input) {
			tenant {
				id
				name
				email
				timezone
				windcaveCustomerId
				netcardCustomerId
				awsUserId
				integrations
				logoUrl
				publicName
				publicEmail
				publicPhoneNumber
			}
		}
	}
`;

export const MODIFY_TENANT_SETTINGS = gql`
	mutation modifyTenantSettingsMutation ($input: ModifyTenantSettingsInput!) {
		modifyTenantSettings (input: $input) {
			tenantsettings {
				id
				salesLast7DaysMode
				averageDailySalesLast7DaysThresholds
				salesLast7DaysThresholds
				expiryDateThresholds
				SPECThresholds
				totalPickItemsQuantityThresholds
				vendoutThresholds
				planogramItemSalesLastXDaysThresholds
				machineProductLastRemovedDateThresholds
				planogramItemDaysSinceLastSale
				temperatureThresholds
				lastCommThresholds
				requiredCoinsThresholds
				requiredCoinsPercentageThresholds
				warehouseStockCanGoNegative
				pickedStockCanExceedWarehouseStock
				quantityDisplayedInCases
				syncProductsWithGlobal
				processRestockWhenNoServiceRun
				enableFreshFoodPerStop
				useProductSizeUnit
				defaultCashCollectionSetting
				oneCashBagPerServiceRun
				defaultCashCollectionAbove
				emailNotificationRecipients
				productDiscontinuationEmailRecipients
				weeklyOperationsEmailRecipients
				weeklyClientsSalesEmailRecipients
				incomingAssetOrderEmailRecipients
				vehicleNotificationEmailRecipients
				sendVehicleRegistrationRenewalEmailNotification
				vehicleRegistrationRenewalEmailNotificationRecipients
				vehicleServiceDueEmailNotificationRecipients
				notificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				marketFeedbackEmailRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				kamCommissionRunFinalisationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				kamCommissionRunFinalisationDeliveryMode
				kamCommissionRunStatementCcRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				kamCommissionRunStatementCcDeliveryMode
				peopleDocumentExpiryNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleDocumentReminderNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleDocumentActionNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleOnboardingCompletionNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleEmployeeEventSubmissionNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleTrainingReminderNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleTrainingReviewNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleProbationReminderNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleXeroSyncFailureNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleEmploymentChangeNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peoplePayrollDetailApprovalNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peoplePayrollLeaveUpdateNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleOvertimeWarningNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleDocumentReminderNotificationDeliveryMode
				peopleDocumentActionNotificationDeliveryMode
				peopleOnboardingCompletionNotificationDeliveryMode
				peopleEmployeeEventSubmissionNotificationDeliveryMode
				peopleTrainingReminderNotificationDeliveryMode
				peopleTrainingReviewNotificationDeliveryMode
				peopleProbationReminderNotificationDeliveryMode
				peopleXeroSyncFailureNotificationDeliveryMode
				peopleEmploymentChangeNotificationDeliveryMode
				peoplePayrollDetailApprovalNotificationDeliveryMode
				peoplePayrollLeaveUpdateNotificationDeliveryMode
				peopleOvertimeWarningNotificationDeliveryMode
				peopleVehicleFineReminderNotificationDeliveryMode
				peopleVehicleFineReminderNotificationRecipients {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleWeeklyDigestEmailRecipients
				emailNotificationRecipientsMode
				emailNotificationDeliveryMode
				emailNotificationRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				productDiscontinuationEmailRecipientsMode
				productDiscontinuationEmailDeliveryMode
				productDiscontinuationEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				weeklyOperationsEmailRecipientsMode
				weeklyOperationsEmailDeliveryMode
				weeklyOperationsEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleWeeklyDigestEmailRecipientsMode
				peopleWeeklyDigestEmailDeliveryMode
				peopleWeeklyDigestEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				weeklyClientsSalesEmailRecipientsMode
				weeklyClientsSalesEmailDeliveryMode
				weeklyClientsSalesEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				incomingAssetOrderEmailRecipientsMode
				incomingAssetOrderEmailDeliveryMode
				incomingAssetOrderEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				vehicleNotificationEmailRecipientsMode
				vehicleNotificationEmailDeliveryMode
				vehicleNotificationEmailRecipientsUsers {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleDocumentReminderNotificationRecipientsMode
				peopleDocumentReminderNotificationRecipientsEmails
				peopleDocumentActionNotificationRecipientsMode
				peopleDocumentActionNotificationRecipientsEmails
				peopleOnboardingCompletionNotificationRecipientsMode
				peopleOnboardingCompletionNotificationRecipientsEmails
				peopleEmployeeEventSubmissionNotificationRecipientsMode
				peopleEmployeeEventSubmissionNotificationRecipientsEmails
				peopleTrainingReminderNotificationRecipientsMode
				peopleTrainingReminderNotificationRecipientsEmails
				peopleTrainingReviewNotificationRecipientsMode
				peopleTrainingReviewNotificationRecipientsEmails
				peopleProbationReminderNotificationRecipientsMode
				peopleProbationReminderNotificationRecipientsEmails
				peopleXeroSyncFailureNotificationRecipientsMode
				peopleXeroSyncFailureNotificationRecipientsEmails
				peopleEmploymentChangeNotificationRecipientsMode
				peopleEmploymentChangeNotificationRecipientsEmails
				peoplePayrollLeaveUpdateNotificationRecipientsMode
				peoplePayrollLeaveUpdateNotificationRecipientsEmails
				peopleOvertimeWarningNotificationRecipientsMode
				peopleOvertimeWarningNotificationRecipientsEmails
				peopleVehicleFineReminderNotificationRecipientsMode
				peopleVehicleFineReminderNotificationRecipientsEmails
				kamCommissionRunFinalisationRecipientsMode
				kamCommissionRunFinalisationRecipientsEmails
				kamCommissionRunStatementCcRecipientsMode
				kamCommissionRunStatementCcRecipientsEmails
				peopleOnboardingChecklistDetails
				peopleOffboardingChecklistDetails
				peopleDefaultSuperannuationFund
				peopleDefaultInjuryEventReviewer {
					id
					firstname
					lastname
					username
					destroyed
				}
				peopleDefaultIncidentEventReviewer {
					id
					firstname
					lastname
					username
					destroyed
				}

				enableServiceRunCreatorPreSelect
				enableServiceRunCreatorCoServiced
				enableServiceRunCreatorLikelyServiceDays
				enableServiceRunCreatorIsolationFilter
				showServiceRunCreatorExclusionHints
				serviceRunPreselectMode
				serviceRunPreselectWeightLimit
				disableServiceRunAdditionsWithoutSitePermissions
				useRosteredDriversForServiceRuns
				defaultMachineServiceType
				defaultMachineRestockType
				defaultRestockEffect
				serviceRunCreatorPreSelectLimits {
					vendouts
					vendoutPredictionTomorrow
					salesSinceLastRestock
					percentageFull
					plannedSalesDailyAverage
					plannedSalesDailyAverageMachine
					plannedSalesDailyAverageMarket
				}
				automaticallyRecalculatePicklists
				automaticallyAssignPickers
				predictivePickLists
				predictivePickListsFromXLastServices
				recalculatePicklistTimeLimit
				machineServiceTime
				defaultMapCoordinates
				performanceReportUpperThreshold
				performanceReportLowerThreshold
				anonymiseReportData
				commissionAbaTraceBsb
				commissionAbaTraceAccountNumber
				commissionAbaFinancialInstitution
				commissionAbaUserNumber
				commissionAbaIncludeSelfBalancingTransaction
				subsidyXeroAccountCode
				subsidyXeroTaxType
				enablePlanogramItemCapacity
				allowEditingPlanogramSelections
				enableTubsFieldOnDockets
				skipWeekendVOP
				skipWeekendMSP
				defaultProductMinPick
				enableTicketsCostsFields
				enableTicketQueues
				disableOtherStateTicketQueues

				requireMachinePhotos
				machinesPhotosIntervalUnit
				machinesPhotosIntervalUnits

				requireMarketPhotos
				marketsPhotosIntervalUnit
				marketsPhotosIntervalUnits
				setPricesFromReportedPrices
				sellProductsNotInMarket
				sortProductsUsingType
				createProductsWhenImportingPlanogram
				balanceProductSwaps
				assignNewPOSToRoute {
					id
					name
				}
				managesSlaveProducts
				managesSlaveConstants
				managesSlaves
				managesSlaveCommissions
				managesSlaveLocationsClients
				managesSlaveMachines
				managesSlaveTags
				managesSlaveClients
				usesMarkets

				hideFutureRunsFromDrivers
				myDayEnabled
				myDayRequireClockIn
				myDayRequireBriefAcknowledgement
				myDayRequireLeaveWarehouseChecklist
				myDayRequireVehicleChecklist
				myDaySelfDebriefMode
				recalculateMachineFuturePicklists
				recalculateUnpickedOnly
				showPickListRecalculationDialog

				machineProductSellingRateWeight
				productSellingRateWeight
				lastRemovedDateWeight
				showVehicleAssignmentDialog
				useExpiryDates
				requireFreshFoodExpiryDates
				showFreshFoodExpiryBeforeNextServiceWarning
				useManualRestockDetails
				enableStockReductionReasonPrompt
				dynamicMinPickEnabled
				dynamicMinPickMultiplier
				dynamicMinPickServicesForAverage
				dynamicMinPickMaxPercentOfParlevel
				maxSalesLast7DaysAchieved
				freshFoodOrderingSettings
			}
		}
	}
`;
